import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../components/Button/Button';
import { useLanguage } from '../../../../locale/useLanguage';
import { Routes } from '../../../../routes/types';

import './DeleteModal.css';
import LoadingFullPage from '../../../../components/LoaderFullPage/LoaderFullPage';

type DeleteModalProps = {
  onEndBenefits: () => void;
  onClose: () => void;
  onMaintainBenefits: () => void;
  deleted?: boolean;
  loading?: boolean;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
  onEndBenefits,
  onMaintainBenefits,
  onClose,
  deleted = false,
  loading = false,
}) => {
  const [t] = useLanguage();
  const history = useHistory();

  const goToBenefits = useCallback(() => {
    history.push(Routes.Benefits);
  }, [history]);

  if (loading)
    return (
      <div style={{ padding: '64px' }}>
        <LoadingFullPage show />
      </div>
    );

  return (
    <div>
      <h2 className="delete-modal--title">
        {deleted
          ? t('profile.accountDeletedModalTitle')
          : t('profile.deleteModalTitle')}
      </h2>
      <p className="delete-modal--description">
        {deleted
          ? t('profile.accountDeletedModalDescription')
          : t('profile.modalFirstDescription')}
      </p>
      <p className="delete-modal--description">
        {deleted ? '' : t('profile.modalSecondDescription')}
      </p>
      {deleted ? (
        <div className="delete-modal--button-container">
          <Button onClick={onClose} isPrimary label={t('profile.close')} />
        </div>
      ) : (
        <>
          <a onClick={goToBenefits} className="link delete-modal--benefits">
            {t('profile.benefits')}
          </a>
          <div className="delete-modal--button-container">
            <Button
              onClick={onMaintainBenefits}
              isPrimary
              label={t('profile.maintainBenefits')}
            />
            <Button onClick={onEndBenefits} label={t('profile.endsBenefits')} />
          </div>
        </>
      )}
    </div>
  );
};
